import React, {useEffect} from "react";
import SearchTable from "../../../primer/Search-Table";
import {useSelector, useDispatch} from "react-redux";
import {getCurrentUser, getOptionsByData} from '../../../../_helpers/commonFunctions';
import {
    fetchAdvancedTypesBuys,
    fetchBuysGeneralSettings,
} from "../../../../_apis/api";
import {useTranslation} from "../../../../hooks/useTranslation";

const BuysSearch = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const buysGeneralSettings = useSelector((state) => state.BUYS_SETTINGS.buysGeneralSettings);
    const advancedTypesBuys = useSelector((state) => state.SETTINGS.settings.advancedTypesBuys);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const documentTypesOptions = getOptionsByData(advancedTypesBuys, "_id", "name");
    const paymentTypeOptions = getOptionsByData(buysGeneralSettings.paymentTypes, "_id", "name");

    const requestData = {
        company: company.id,
        year: company.year.toString(),
    };
    const currentUser = getCurrentUser();
    const requestData2 = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active",
        userId: currentUser.id
    };
    useEffect(() => {
        dispatch(fetchAdvancedTypesBuys(requestData));
        dispatch(fetchBuysGeneralSettings(requestData2))
    }, []);

    const ssColumns = [
        {
            name: t("General.date"),
            field: "date",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.supplier"),
            field: "supplierName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.documentType"),
            field: "documentTypeName",
            width: "250px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.number"),
            field: "preNumberAndNumber",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.totalNetValue"),
            field: "totalNetValue",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t("General.totalVatValue"),
            field: "totalVatValue",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t("General.totalValue"),
            field: "totalAmount",
            width: "100px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t('General.myDataStatus'),
            field: "myDataStatus",
            width: "100px",
            editable: false,
            inputType: {
                type: 'text',
            }
        }
    ]

    const searchBuyFilters = {
        filters: [
            {
                name: "documentType",
                label: t("General.documentType"),
                type: "multiselect",
                options: documentTypesOptions
            },
            {
                name: "supplierName",
                label: t("General.supplierNameVAT"),
                type: "input",
            },
            {
                name: "productName",
                label: t("General.includingProductName"),
                type: "input",
            },
            {
                name: "paymentWay",
                label: t("General.paymentType"),
                type: "multiselect",
                options: paymentTypeOptions,
            },
            {
                name: "totalSum_from",
                label: t("General.totalSumFrom"),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "totalSum_to",
                label: t("General.totalSumTo"),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "anamorfosis_from",
                label: "Ποσό αναμόρφωσης από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "anamorfosis_to",
                label: "Ποσό αναμόρφωσης έως",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_from",
                label: t("General.preNumberFrom"),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "preNumber_to",
                label: t("General.preNumberTo"),
                type: "input",
                mdWidth: 2,
            },
            {
                name: "number_from",
                label: t("General.numberFrom"),
                type: "number",
                mdWidth: 2,
            },
            {
                name: "number_to",
                label: t("General.numberTo"),
                type: "number",
                mdWidth: 2,
            },
            {
                name: "notes",
                label: t("General.notes"),
                type: "input"
            }
        ],
    };

    return (
        <div>
            <SearchTable
                tableName="Buys Search"
                key={"Buys Search"}
                hideYearFilter={false}
                allowPagination={true}
                allowPrintResults={true}
                dataEndpoint={"/buy/buys-search-data"}
                exportFileName={"Αγορές"}
                columns={ssColumns}
                data={[]}
                filtersConfig={searchBuyFilters}
            />
        </div>
    )
}

export default BuysSearch;
